export const POST_PDF = '@uhc/utility/POST_PDF';
export const CLEAR_RESULTS = '@uhc/utility/CLEAR_RESULTS';
